import React, { useState } from "react";
import { useSelector } from "react-redux";
import { useJobsData } from "../../hooks/useJobsData";
import { Box, Pagination, Table, Title } from "@allxsmith/bestax-bulma";
import { getJobsData } from "../../state/selectors";
import Spinner from "react-spinner-material";
import { readableDate } from "../../utils";

function Jobs() {
  const [page, setPage] = useState(1);
  const complete = useJobsData({ view: "today", page: page, ws: "all" });
  const data = useSelector(getJobsData);
  if (!complete) {
    return (
      <Box>
        <Spinner
          className="spinner-centre"
          size={120}
          spinnerColor={"#3273dc"}
          spinnerWidth={2}
        />
      </Box>
    );
  }

  // TODO(bestax-migrate): `showFirstLast` — no showFirstLast prop in bestax Pagination
  return (
    <Box>
      <Title size="5">Jobs Starting Today</Title>
      <Table isFullwidth>
        <thead>
          <tr>
            <th>ID</th>
            <th>Registration</th>
            <th>Customer</th>
            <th>Customer 2</th>
            <th>Make</th>
            <th>Model</th>
            <th>Book In Date</th>
            <th>Start Date</th>
            <th>Workshop</th>
            <th>Comments</th>
          </tr>
        </thead>
        <tbody>
          {data.results.map(value => (
            <tr
              className="clickable"
              style={{ fontSize: 12 }}
              onClick={() => window.open(`/editjob/${value.id}`, "_self")}
              key={value.id}
            >
              <td>{value.id}</td>
              <td>{value.vehicle ? value.vehicle.registration:  ""}</td>
              <td>{value.customer ? value.customer.display_name : ""}</td>
              <td>
                {value.customer2 ? value.customer2.display_name : ""}
              </td>
              <td>{value.vehicle ? value.vehicle.make ? value.vehicle.make.name : "" : ""}</td>
              <td>{value.vehicle ? value.vehicle.model ? value.vehicle.model.name : "" : ""}</td>
              <td>{readableDate(value.workshop_date)}</td>
              <td>{readableDate(value.book_in_date)}</td>
              <td>{value.workshop ? value.workshop.display_name : ""}</td>
              <td>{value.comments_list.length > 0 ? value.comments_list[value.comments_list.length -1].text : ""}</td>
            </tr>
          ))}
        </tbody>
      </Table>
      <Pagination
        showFirstLast={true}
        onPageChange={page => setPage(page)}
        current={page}
        total={Math.ceil(data.count / 25)}
      >
        {" "}
      </Pagination>
    </Box>
  );
}

export default Jobs;
